export default __webpack_public_path__ + "static/media/list.74f622b4.svg";